export const getUsersStatusLabel = (active, invite) => {
    if (invite) {
        return 'Invited';
    } else if (active) {
        return 'Active';
    } else {
        return 'Disabled';
    }
};
